import React from "react";
import { cn } from "@/lib/utils";

interface AssetButtonProps {
    asset: {
        symbol: string;
        image?: string;
    };
    className?: string;
    onClick?: () => void;
    seletable?: boolean;
    error?: boolean;
}

export const AssetButton: React.FC<AssetButtonProps> = ({
    asset,
    className,
    onClick,
    seletable = true,
    error = false,
}) => {
    return (
        <button
            type="button"
            className={cn(
                "flex items-center gap-1.5 p-1.5 pr-3 rounded-full transition-colors border w-fit",
                asset.symbol === "TON"
                    ? "bg-ton border-ton"
                    : asset.symbol === "USDT"
                      ? "bg-usdt border-usdt"
                      : "bg-primary/20 border-primary/20",
                error ? "bg-orange-600/20 border-orange-600/20" : "",
                className,
                !seletable && "!cursor-default !pointer-events-none",
            )}
            onClick={onClick}
        >
            <img
                src={asset.image || `/images/swap/${asset.symbol?.toLowerCase() || "usdt"}.svg`}
                width={24}
                height={24}
                alt={asset.symbol || ""}
                className="object-contain rounded-full"
                onError={(e) => {
                    const jettonFallback = "/images/jettonFallback.svg";
                    if ((e.target as HTMLImageElement).src !== jettonFallback) {
                        (e.target as HTMLImageElement).src = jettonFallback;
                    }
                }}
            />
            <span className="text-sm font-medium">{asset.symbol}</span>
            {seletable && (
                <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-1"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.810782 1.14863C1.00485 0.906045 1.35883 0.866714 1.60141 1.06078L5.00002 3.77967L8.39863 1.06078C8.64122 0.866714 8.99519 0.906045 9.18926 1.14863C9.38333 1.39121 9.344 1.74519 9.10141 1.93926L5.35141 4.93926C5.14598 5.10361 4.85407 5.10361 4.64863 4.93926L0.89863 1.93926C0.656045 1.74519 0.616714 1.39121 0.810782 1.14863Z"
                        fill="white"
                    />
                </svg>
            )}
        </button>
    );
};
